module.exports = __webpack_public_path__ + "img/MAC1133_1-1.c9e307ca.jpg";